module.exports = __webpack_public_path__ + "img/class5.b6dbefe2.png";